module.exports = __webpack_public_path__ + "kec-cover.603f5dbc83c2e152dbf90c9e750e45c2.png";